<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'name'"
      :validated="formObserver.validated && observer.failed"
      v-bind="observer"
    >
      <!-- FIRST NAME -->
      <form-row
        :label="label"
        :question="subtitle || 'Please provide both first and last names'"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_first-name`"
          name="First name"
          :rules="questionRules"
          tag="div"
        >
          <qz-text-field
            v-model="questionData[questionFields.firstName]"
            :data-test="fieldTrackerId.name"
            :error-messages="getNameErrors(errors)"
            label="First name"
            :maxlength="inputCharsLimiters.NAME"
            autocomplete="given-name"
            @keyup="helpers.limitInputChars(questionData, questionFields.firstName, inputCharsLimiters.NAME)"
            @blur="onBlurName($event, questionFields.firstName)"
          />
        </validation-provider>
        <!-- LAST NAME -->
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_surname`"
          name="Last name"
          :rules="questionRules"
          class="mt-6"
          tag="div"
        >
          <qz-text-field
            v-model="questionData[questionFields.surname]"
            class="mt-4"
            :data-test="fieldTrackerId.surname"
            :error-messages="getNameErrors(errors)"
            label="Last name"
            :maxlength="inputCharsLimiters.NAME"
            autocomplete="family-name"
            @keyup="helpers.limitInputChars(questionData, questionFields.surname, inputCharsLimiters.NAME)"
            @blur="onBlurName($event, questionFields.surname)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  snakeCase,
  upperFirst,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-name',
  extends: QuestionBase,
  data () {
    return {
      fields: ['firstName', 'surname'],
    };
  },
  computed: {
    questionRules () {
      return {
        name: {
          min: 2,
          max: 50,
          isAdditional: this.isAdditional,
        },
      };
    },
    label () {
      if (!this.isAdditional) {
        return this.title || 'What is your name?';
      }

      return this.titleAdditional || this.title || 'What is their name?';
    },
    fieldTrackerId () {
      return {
        name: snakeCase(this.questionFields.firstName),
        surname: snakeCase(this.questionFields.surname),
      };
    },
  },
  methods: {
    onBlurName (event, field) {
      if (!this.questionData[field]) return;

      let name = this.questionData[field]
        .replace(/^[-, ]+/g, '')
        .replace(/[-, ]+$/g, '')
        .replace(/(\s?-\s?)/g, '-')
        .replace(/  +/g, ' ')
        .replace(/--+/g, '-');

      name = upperFirst(
        name
          .split('')
          .map((letter, i) => / |-/.test(name[i - 1]) ? letter.toUpperCase() : letter.toLowerCase())
          .join(''),
      );

      this.questionData[field] = name;
    },
    getNameErrors (errors) {
      return errors.map(error => {
        return this.isAdditional ? error.replace('your', 'their') : error;
      });
    },
  },
};
</script>
